import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchMyPicks, setWeekLock, upsertPick } from './api'

export function useMyPicks(poolId: string | undefined, weekId: string | undefined) {
  return useQuery({
    queryKey: ['picks', poolId, weekId],
    queryFn: () => fetchMyPicks(poolId!, weekId!),
    enabled: Boolean(poolId && weekId),
  })
}

export function useSetWeekLock() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: setWeekLock,
    onSuccess: (_pick, variables) => {
      // Same prefix invalidation as useUpsertPick, and necessary here rather
      // than optional: moving the lock writes two rows, so refetching the
      // week's picks is the only way the cleared one is reflected too.
      void queryClient.invalidateQueries({ queryKey: ['picks', variables.poolId] })
    },
  })
}

export function useUpsertPick() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: upsertPick,
    onSuccess: (_pick, variables) => {
      // Prefix match: ['picks', poolId] invalidates every ['picks', poolId,
      // weekId] entry. upsertPick has no reason to know the week — picks reach
      // weeks through games — so keying the invalidation on the pool avoids
      // threading a week id through the mutation just to clear a cache.
      void queryClient.invalidateQueries({ queryKey: ['picks', variables.poolId] })
    },
  })
}
